import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import TransitionContainer from '../../components/Transition/TranstionContainer';

import VoteRegistrationStep6Form from '../../components/VoteRegistration/VoteRegistrationStep6Form';

import { PrefixList, SuffixList } from '../../utils/enums';

import { onGoToStep, saveForm } from './actions';
import { cacheFormData } from '../../utils/formCaching/actions';
import {
    widgetBounce,
    setExitingCardProps,
    getExitingCardProps
} from '../Widget/actions';

import {
    ContainerStyled,
    LegalInfoWrapper,
    FormWrapper
} from '../DefaultStyles/AssessmentDetails';

import VoteRegistrationSidebar from '../../components/VoteRegistration/VoteRegistrationSidebar';

import LegalInfo from '../../components/Widget/LegalInfo';

const VoteRegistrationStep6 = props => (
    <TransitionContainer
        isSubmitting={props.isSubmitting}
        isBackTransition={props.isBackTransition}
        zIndex={30}
    >
        <ContainerStyled>
            <VoteRegistrationSidebar loadRep={true} title={'Voter Registration'} />
            <FormWrapper>
                <VoteRegistrationStep6Form
                    prefix={props.prefix}
                    suffix={props.suffix}
                    onBack={() => {
                        if (!props.bounceDismissed) {
                            props.widgetBounce(
                                true,
                                props.widgetRequestId,
                                props.articleUrl,
                                props.currentFormValues,
                                props.actionIdentifier
                            );
                        } else {
                            props.setExitingCardProps(
                                'voteRegistration',
                                props,
                                props.activeAction
                            );
                            props.onGoToStep(
                                5,
                                'back',
                                null,
                                null,
                                [4, 5],
                                props.formData
                            );
                        }
                    }}
                    onSubmit={values => {
                        props.cacheFormData(values);
                        props.setExitingCardProps(
                            'voteRegistration',
                            props,
                            props.activeAction
                        );
                        props.saveForm(values, [7], null, props.formData);
                    }}
                    validationErrors={props.validationErrors}
                />
                {props.isMobileResolution && (
                    <LegalInfoWrapper>
                        <LegalInfo />
                    </LegalInfoWrapper>
                )}
            </FormWrapper>
        </ContainerStyled>
    </TransitionContainer>
);

VoteRegistrationStep6.propTypes = {
    activeAction: PropTypes.object.isRequired,
    onGoToStep: PropTypes.func.isRequired,
    saveForm: PropTypes.func.isRequired,
    prefix: PropTypes.array.isRequired,
    suffix: PropTypes.array.isRequired,
    formData: PropTypes.object,
    isSubmitting: PropTypes.bool,
    isBackTransition: PropTypes.bool,
    isMobileResolution: PropTypes.bool,
    cacheFormData: PropTypes.func.isRequired,
    setExitingCardProps: PropTypes.func.isRequired,
    bounceDismissed: PropTypes.bool.isRequired,
    actionIdentifier: PropTypes.string.isRequired,
    currentFormValues: PropTypes.object.isRequired,
    articleUrl: PropTypes.string.isRequired,
    widgetRequestId: PropTypes.string.isRequired,
    widgetBounce: PropTypes.func.isRequired,
    validationErrors: PropTypes.object
};

export default connect(
    (state, props) => {
        const exitingProps = getExitingCardProps(
            'voteRegistration',
            ['/voteRegistration/step6'],
            props.location.pathname,
            state
        );
        if (exitingProps) return exitingProps;

        return {
            activeAction: state.widget.activeAction,
            prefix: PrefixList,
            suffix: SuffixList,
            formData: state.voteRegistration.formData,
            isSubmitting: state.voteRegistration.isSubmitting,
            isBackTransition: state.voteRegistration.isBackTransition,
            isMobileResolution: state.widget.isMobileResolution,
            actionIdentifier: state.widget.activeAction.identifier,
            bounceDismissed: state.widget.bounceDismissed,
            widgetRequestId: state.widget.widgetRequestId,
            articleUrl: state.widget.articleUrl,
            currentFormValues: (state.form['voteRegistrationStep6Form'] || {}).values,
            validationErrors: (state.form['voteRegistrationStep6Form'] || {}).syncErrors
        };
    },
    { widgetBounce, onGoToStep, saveForm, cacheFormData, setExitingCardProps }
)(VoteRegistrationStep6);
